// extracted by css-extract-rspack-plugin
export default {"container":"_36230985","inputWrapper":"_2793e387","spinner":"_de28505f"};